<template>
	<div
		class="view-content__wrapper">
		<div class="view-content mx-auto">
			<div class="mb-6 headline-1">
				{{ $t("menu-items.please_login") }}
			</div>
			<Alert v-if="getError" />
			<div>
				<e-tabs
					class="mb-6"
					:value="0"
					:grow="true"
					:small="false"
					:large="false">
					<e-tab
						v-for="loginMethod in primaryLoginMethods"
						:key="loginMethod"
						class="body-3 pl-0 pr-0"
						@click="navigate(loginMethod)">
						{{ $t("menu-items." + loginMethod) }}
					</e-tab>
					<e-menu
						bottom=""
						minWidth="160"
						nudgeBottom="8"
						offsetY="">
						<template #activator="{on, attrs}">
							<e-tab
								v-bind="attrs"
								activator
								v-on="on">
								<e-icon>
									icon-chevron-down
								</e-icon>
							</e-tab>
						</template>
						<e-menu-list>
							<e-menu-list-item
								v-for="loginMethod in secondaryLoginMethods"
								:key="loginMethod"
								@click="navigate(loginMethod)">
								{{ $t("menu-items." + loginMethod) }}
							</e-menu-list-item>
						</e-menu-list>
					</e-menu>
				</e-tabs>
			</div>
			<transition
				name="fade"
				mode="out-in">
				<Password v-if="activeItem == 'password'" />
				<Mobile v-if="activeItem == 'mobile_id'" />
				<Smart v-if="activeItem == 'smart_id'" />
				<Har v-if="activeItem == 'har_id'" />
				<XId v-if="activeItem == 'x_id'" />
				<Card v-if="activeItem == 'id_card'" />
				<EParaksts v-if="activeItem == 'e_paraksts'" />
			</transition>
			<div
				v-if="!miniView && project == 'eKool' && !mobileCodeSent && !smartCodeSent && !smartLoggedIn && !mobileLoggedIn"
				class="mt-4 text-center d-block d-sm-flex align-center justify-center">
				<span class="subhead-2 greybase-text mr-2">{{ $t('menu-items.new_to_ekool') }}</span>
				<e-button
					variant="link"
					small=""
					:block="false"
					:to="'/' + $i18n.locale + '/register'">
					{{ $t('menu-items.create_account') }}
				</e-button>
			</div>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src

import Password from "@/components/Password.vue";
import Mobile from "@/components/Mobile.vue";
import Smart from "@/components/Smart.vue";
import Har from "@/components/Har.vue";
import Card from "@/components/Card.vue";
import XId from "@/components/XId.vue";
import EParaksts from "@/components/eParaksts.vue";

import Alert from "@/components/Alert.vue";
import { mapGetters, mapState } from 'vuex';

import { getEnv } from "../env";
export default {
	components: {
		Password,
		Mobile,
		Smart,
		Har,
		Card,
		Alert,
		XId,
		EParaksts,
	},
	data () {
		return {
			activeItem: "password",
			project: getEnv('VUE_APP_FRONTEND_PROJECT_NAME'),
			primaryLoginMethods: getEnv('VUE_APP_FRONTEND_PRIMARY_LOGIN_METHODS').split(", "),
			secondaryLoginMethods: getEnv('VUE_APP_FRONTEND_SECONDARY_LOGIN_METHODS').split(", "),
		};
	},
	computed: {
		...mapGetters([
			'getError',
			'mobileCodeSent',
			'smartCodeSent',
			'smartLoggedIn',
			'mobileLoggedIn',
		]),
		...mapState ([
			'miniView',
		]),
	},
	mounted () {
		if(this.$route.name == "login-mini" || this.$route.name == 'thirdParty'){
			this.$store.commit("setMiniView",true);
			this.$store.commit("setMiniViewFunction", this.postLoginMessage);
		}
		else if(this.$route.name == "mobile"){
			this.$store.commit("setMobileView",true);
		}

		if(this.$route.params.error){
			if(this.$i18n.te(this.$route.params.error)){
				this.$store.commit("changeError",
					this.$route.params.error);
				this.$store.commit("showError",true);
			}
			else{
				this.$store.commit("changeError",
					("repeating_errors." + this.$route.params.error));
				this.$store.commit("showError",true);
			}

		}
		else if(this.$route.query.error){
			if(this.$i18n.te(this.$route.query.error)){
				this.$store.commit("changeError",
					this.$route.query.error);
				this.$store.commit("showError",true);
			}
			else{
				this.$store.commit("changeError",
					("repeating_errors." + this.$route.query.error));
				this.$store.commit("showError",true);
			}
		}

		if(this.$route.name == 'mobile'){
			//remove id-card login method in mobile view
			this.primaryLoginMethods = this.primaryLoginMethods.filter(e => e !== 'id_card')
		}	
		else{
			//if not mobile view, take login methods from env
			this.primaryLoginMethods = getEnv('VUE_APP_FRONTEND_PRIMARY_LOGIN_METHODS').split(", ")
		}
	},
	methods: {
		navigate (item) {
			this.activeItem = item;
			this.$store.commit("showError", false);
		},
	},

};
</script>